import React from "react";
import {
  Router,
  Route,
  Redirect,
  IndexRoute,
  browserHistory
} from "react-router";

import Auth from "routes/Auth";
import App from "App";
import {
  Decisions,
  CeoDecisions,
  PDDecisions,
  PMDecisions,
  OperationsDecisions,
  FinanceDecisions,
  Analysis,
  MarketAnalysis,
  CompetitiveAnalysis,
  EconomicAnalysis,
  FinancialAnalysis,
  Results,
  KnowledgeBase,
  FNAnalysisFNStatements,
  FNAnalysisFNStatementsIncomeStatement,
  FNAnalysisFNStatementsCashFlow,
  FNAnalysisFNStatementsBalanceSheet,
  WelcomePage,
  LoginPage,
  IntroVideoPage,
  RegisterPage,
  JoinPage,
  ResetPasswordPage,
  AccountVerify,
  ResetPassword,
  InstructorDashboard,
  InstructorCourseManagement,
  InstructorGameManagement,
  InstructorRoundManagement,
  InstructorTeamManagement,
  InstructorPerformanceFeedback,
  InstructorPeerFeedback,
  InstructorTeamEvaluation,
  InstructorTeamsRoles,
  InstructorFinalScores,
  InstructorRoundAdmin,
  InstructorWelcomePage,
  InstructorOnboardingPage,
  InstructorDemoPage,
  InstructorGoalsAndTargets,
  InstructorGrading,
  AuditTrail,
  Dashboard,
  PromoCodePage,
  BusinessCase,
  MyProfilePage,
  OnboardingPage,
  PerformanceFeedback,
  GoalsAndTargets,
  PeerFeedback,
  PeerReview,
  RoundTriviaPage,
  StartPage,
} from "./routes";

function wrap(callback) {
  return (nextState, replace) => {
    logRequest(nextState.location);
    callback(nextState, replace);
  };
}

function redirectToLogin(nextState, replace) {
  const queryParams = new URLSearchParams(nextState.location.search);
  const auth = parseInt(queryParams.get("auth"));

  if (auth) {
    const token = queryParams.get("_token")
    const user_id = queryParams.get("user_id")
    const position = queryParams.get("position")
    const game_id = queryParams.get("game_id")
    const course_id = queryParams.get("course_id")

    Auth.authenticateUser(token, user_id, position, game_id, course_id)
  }

  if (!Auth.isUserAuthenticated()) {
    replace({
      pathname: "/welcome",
      state: { nextPathname: nextState.location.pathname }
    });
  }
}

const redirectToLoginWrapper = wrap(redirectToLogin);

function redirectToHome(nextState, replace) {
  if (Auth.isUserAuthenticated()) {
    if (Auth.getPosition() === "Student") {
      replace({
        pathname: "/start",
        state: { nextPathname: nextState.location.pathname }
      });
    } else {
      replace({
        pathname: "/instructor/dashboard",
        state: {
          nextPathname: nextState.location.pathname
        }
      });
    }
  }
}

const redirectToHomeWrapper = wrap(redirectToHome);

function indexRedirect(nextState, replace) {
  if (nextState.location.pathname === "/") {
    if (Auth.isUserAuthenticated()) {
      if (Auth.getPosition() === "Student") {
        replace({
          pathname: "/start",
          state: { nextPathname: nextState.location.pathname }
        });
      } else {
        replace({
          pathname: "/instructor/dashboard",
          state: {
            nextPathname: nextState.location.pathname
          }
        });
      }
    } else {
      replace({
        pathname: "/welcome",
        state: {
          nextPathname: nextState.location.pathname
        }
      });
    }
  }
}

const indexRedirectWrapper = wrap(indexRedirect);

function logRequestWrapper(nextState, replace) {
  logRequest(nextState.location);
}

export function logRequest(location) {
  const excluded = [
    "welcome",
    "login",
    "register",
    "join",
    "reset-password",
    "verify",
    "instructor",
    "team-reports",
    "promo-code",
    "onboarding",
    "round-trivia",
    "start"
  ];
  const routes = location.pathname.split("/").filter(i => i !== "");
  let params = [];
  for (var key in location.query) {
    params.push(key + "=" + location.query[key]);
  }
  const fullUrl =
    params.length > 0
      ? location.pathname + "?" + params.join("&")
      : location.pathname;

  if (routes.length > 0 && !excluded.includes(routes[0])) {
    sessionStorage.setItem("previousLocation", fullUrl);
  }
}

const changedPage = () => {
  if (window && window.Appcues) {
    window.Appcues.page();
  }
}

const Routes = (
  <Router history={browserHistory} onUpdate={() => changedPage()}>
    <Route path="/" component={App} onEnter={indexRedirectWrapper}>
      <Route
        path="welcome"
        onEnter={redirectToHomeWrapper}
        component={WelcomePage}
      />
      <Route
        path="login"
        onEnter={redirectToHomeWrapper}
        component={LoginPage}
      />
      <Route
        path="register"
        onEnter={redirectToHomeWrapper}
        component={RegisterPage}
      />
      <Route
        path="join"
        onEnter={redirectToLoginWrapper}
        component={JoinPage}
      />
      <Route
        path="reset-password"
        onEnter={redirectToHomeWrapper}
        component={ResetPasswordPage}
      />
      <Route
        path="verify/:token"
        onEnter={redirectToHomeWrapper}
        component={AccountVerify}
      />
      <Route
        path="reset-password/:token1/:token2"
        onEnter={redirectToHomeWrapper}
        component={ResetPassword}
      />
      <Route
        path="promo-code"
        onEnter={redirectToLoginWrapper}
        component={PromoCodePage}
      />
      <Route
        path="profile"
        onEnter={redirectToLoginWrapper}
        component={MyProfilePage}
      />
      <Route
        path="scoring-breakdown"
        onEnter={redirectToLoginWrapper}
        component={MyProfilePage}
      />
      <Route
        path="start"
        onEnter={redirectToLoginWrapper}
        component={StartPage}
      />
      <Route
        path="intro-video"
        onEnter={redirectToLoginWrapper}
        component={IntroVideoPage}
      />
      <Route
        path="demo"
        onEnter={redirectToLoginWrapper}
        component={InstructorDemoPage}
      />
      <Route
        path="onboarding"
        onEnter={redirectToLoginWrapper}
        component={OnboardingPage}
      />
      <Route
        path="onboarding/:category"
        onEnter={redirectToLoginWrapper}
        component={OnboardingPage}
      />
      <Route
        path="onboarding/:category/:step"
        onEnter={redirectToLoginWrapper}
        component={OnboardingPage}
      />
      <Route
        path="round-trivia"
        onEnter={redirectToLoginWrapper}
        component={RoundTriviaPage}
      />
      <Route
        path="round-trivia/:category"
        onEnter={redirectToLoginWrapper}
        component={RoundTriviaPage}
      />
      <Route
        path="round-trivia/:category/:step"
        onEnter={redirectToLoginWrapper}
        component={RoundTriviaPage}
      />
      <Route
        path="goals-and-targets"
        onEnter={redirectToLoginWrapper}
        component={GoalsAndTargets}
      />
      <Route
        path="peer-feedback"
        onEnter={redirectToLoginWrapper}
        component={PeerFeedback}
      />
      <Route
        path="peer-feedback/:alias1"
        onEnter={redirectToLoginWrapper}
        component={PeerFeedback}
      />
      <Route
        path="peer-feedback/:alias1/:alias2"
        onEnter={redirectToLoginWrapper}
        component={PeerFeedback}
      />
      <Route
        path="performance-feedback"
        onEnter={redirectToLoginWrapper}
        component={PerformanceFeedback}
      />
      <Route
        path="performance-feedback/:alias1"
        onEnter={redirectToLoginWrapper}
        component={PerformanceFeedback}
      />
      <Route
        path="performance-feedback/:alias1/:alias2"
        onEnter={redirectToLoginWrapper}
        component={PerformanceFeedback}
      />
      <Route path="instructor" onEnter={redirectToLoginWrapper}>
        <IndexRoute
          onEnter={logRequestWrapper}
          component={InstructorDashboard}
        />
        <Route
          path="dashboard"
          onEnter={logRequestWrapper}
          component={InstructorDashboard}
        />
        <Route
          path="welcome"
          onEnter={logRequestWrapper}
          component={InstructorWelcomePage}
        />
        <Route
          path="welcome/:category"
          onEnter={logRequestWrapper}
          component={InstructorWelcomePage}
        />
        <Route
          path="welcome/:category/:step"
          onEnter={logRequestWrapper}
          component={InstructorWelcomePage}
        />
        <Route
          path="onboarding"
          onEnter={logRequestWrapper}
          component={InstructorOnboardingPage}
        />
        <Route
          path="onboarding/:step"
          onEnter={logRequestWrapper}
          component={InstructorOnboardingPage}
        />
        <Route
          path="course-management"
          onEnter={logRequestWrapper}
          component={InstructorCourseManagement}
        />
        <Route
          path="goals-and-targets"
          onEnter={logRequestWrapper}
          component={InstructorGoalsAndTargets}
        />
        <Route
          path="game-management"
          onEnter={logRequestWrapper}
          component={InstructorGameManagement}
        />
        <Route
          path="round-management/:game_id"
          onEnter={logRequestWrapper}
          component={InstructorRoundManagement}
        />
        <Route
          path="team-management/:game_id"
          onEnter={logRequestWrapper}
          component={InstructorTeamManagement}
        />
        <Route
          path="performance-feedback"
          onEnter={logRequestWrapper}
          component={InstructorPerformanceFeedback}
        />
        <Route
          path="performance-feedback/:alias1"
          onEnter={logRequestWrapper}
          component={InstructorPerformanceFeedback}
        />

        <Route
          path="performance-feedback/:alias1/:alias2"
          onEnter={logRequestWrapper}
          component={InstructorPerformanceFeedback}
        />
        <Route
          path="peer-feedback"
          onEnter={logRequestWrapper}
          component={InstructorPeerFeedback}
        />
        <Route
          path="peer-feedback/:alias1"
          onEnter={logRequestWrapper}
          component={InstructorPeerFeedback}
        />
        <Route
          path="peer-feedback/:alias1/:alias2"
          onEnter={logRequestWrapper}
          component={InstructorPeerFeedback}
        />
        <Route
          path="peer-review"
          onEnter={logRequestWrapper}
          component={InstructorTeamEvaluation}
        />
        <Route
          path="teams-roles"
          onEnter={logRequestWrapper}
          component={InstructorTeamsRoles}
        />
        <Route
          path="final-scores"
          onEnter={logRequestWrapper}
          component={InstructorFinalScores}
        />
        <Route
          path="rounds"
          onEnter={logRequestWrapper}
          component={InstructorRoundAdmin}
        />
        <Route
          path="grading"
          onEnter={logRequestWrapper}
          component={InstructorGrading}
        />
        <Route
          path="grading/:alias1"
          onEnter={logRequestWrapper}
          component={InstructorGrading}
        />
      </Route>
      <Redirect path="team-reports" to="analysis/team-reports" />
      <Route path="decisions" onEnter={logRequestWrapper} component={Decisions} />
      <Route path="decisions/ceo" onEnter={logRequestWrapper} component={CeoDecisions} />
      <Route path="decisions/product-development" onEnter={logRequestWrapper} component={PDDecisions} />
      <Route path="decisions/product-marketing" onEnter={logRequestWrapper} component={PMDecisions} />
      <Route path="decisions/operations" onEnter={logRequestWrapper} component={OperationsDecisions} />
      <Route path="decisions/finance" onEnter={logRequestWrapper} component={FinanceDecisions} />
      <Route
        path="peer-review"
        onEnter={redirectToLoginWrapper}
        component={PeerReview}
      />
      <Route path="ceo" onEnter={redirectToLoginWrapper}>
        <IndexRoute onEnter={logRequestWrapper} component={Analysis} />
        <Route
          path="audit-trail"
          onEnter={logRequestWrapper}
          component={AuditTrail}
        />
        <Route path="analysis" onEnter={logRequestWrapper}>
          <IndexRoute onEnter={logRequestWrapper} component={Analysis} />
          <Route
            path="market"
            onEnter={logRequestWrapper}
            component={MarketAnalysis}
          />
          <Route
            path="financial"
            onEnter={logRequestWrapper}
            component={FinancialAnalysis}
          />
          <Route
            path="competitive"
            component={CompetitiveAnalysis}
            onEnter={logRequestWrapper}
          />
          <Route
            path="economic"
            onEnter={logRequestWrapper}
            component={EconomicAnalysis}
          />
        </Route>
        <Route path="results" onEnter={logRequestWrapper}>
          <IndexRoute onEnter={logRequestWrapper} component={Results} />
          <Route
            path="FinancialAnalysis"
            onEnter={logRequestWrapper}
            component={FNAnalysisFNStatements}
          >
            <IndexRoute
              onEnter={logRequestWrapper}
              component={FNAnalysisFNStatementsIncomeStatement}
            />
            <Route
              path="IncomeStatement"
              component={FNAnalysisFNStatementsIncomeStatement}
              onEnter={logRequestWrapper}
            />
            <Route
              path="CashFlow"
              onEnter={logRequestWrapper}
              component={FNAnalysisFNStatementsCashFlow}
            />
            <Route
              path="BalanceSheet"
              component={FNAnalysisFNStatementsBalanceSheet}
              onEnter={logRequestWrapper}
            />
          </Route>
          <Route
            path="competitive"
            component={CompetitiveAnalysis}
            onEnter={logRequestWrapper}
          />
          <Route
            path="ValuationsResults"
            onEnter={logRequestWrapper}
            component={Results}
          />
        </Route>
        {/* <Route
          path="knowledge-base"
          onEnter={logRequestWrapper}
          component={KnowledgeBase}
        /> */}
      </Route>
      <Route path="pd" onEnter={redirectToLoginWrapper}>
        <IndexRoute onEnter={logRequestWrapper} component={Analysis} />
        <Route
          path="audit-trail"
          onEnter={logRequestWrapper}
          component={AuditTrail}
        />
        <Route path="analysis" onEnter={logRequestWrapper}>
          <IndexRoute onEnter={logRequestWrapper} component={Analysis} />
          <Route
            path="market"
            onEnter={logRequestWrapper}
            component={MarketAnalysis}
          />
          <Route
            path="financial"
            onEnter={logRequestWrapper}
            component={FinancialAnalysis}
          />
          <Route
            path="competitive"
            component={CompetitiveAnalysis}
            onEnter={logRequestWrapper}
          />
          <Route
            path="economic"
            onEnter={logRequestWrapper}
            component={EconomicAnalysis}
          />
        </Route>
        <Route path="results" onEnter={logRequestWrapper}>
          <IndexRoute onEnter={logRequestWrapper} component={Results} />
          <Route
            path="FinancialAnalysis"
            onEnter={logRequestWrapper}
            component={FNAnalysisFNStatements}
          >
            <IndexRoute
              onEnter={logRequestWrapper}
              component={FNAnalysisFNStatementsIncomeStatement}
            />
            <Route
              path="IncomeStatement"
              component={FNAnalysisFNStatementsIncomeStatement}
              onEnter={logRequestWrapper}
            />
            <Route
              path="CashFlow"
              onEnter={logRequestWrapper}
              component={FNAnalysisFNStatementsCashFlow}
            />
            <Route
              path="BalanceSheet"
              component={FNAnalysisFNStatementsBalanceSheet}
              onEnter={logRequestWrapper}
            />
          </Route>
          <Route
            path="competitive"
            component={CompetitiveAnalysis}
            onEnter={logRequestWrapper}
          />
          <Route
            path="ValuationsResults"
            onEnter={logRequestWrapper}
            component={Results}
          />
        </Route>
        <Route
          path="knowledge-base"
          onEnter={logRequestWrapper}
          component={KnowledgeBase}
        />
      </Route>
      <Route path="pm" onEnter={redirectToLoginWrapper}>
        <IndexRoute onEnter={logRequestWrapper} component={Analysis} />
        <Route
          path="audit-trail"
          onEnter={logRequestWrapper}
          component={AuditTrail}
        />
        <Route path="analysis" onEnter={logRequestWrapper}>
          <IndexRoute onEnter={logRequestWrapper} component={Analysis} />
          <Route
            path="market"
            onEnter={logRequestWrapper}
            component={MarketAnalysis}
          />
          <Route
            path="financial"
            onEnter={logRequestWrapper}
            component={FinancialAnalysis}
          />
          <Route
            path="competitive"
            component={CompetitiveAnalysis}
            onEnter={logRequestWrapper}
          />
          <Route
            path="economic"
            onEnter={logRequestWrapper}
            component={EconomicAnalysis}
          />
        </Route>
        <Route path="results" onEnter={logRequestWrapper}>
          <IndexRoute onEnter={logRequestWrapper} component={Results} />
          <Route
            path="FinancialAnalysis"
            onEnter={logRequestWrapper}
            component={FNAnalysisFNStatements}
          >
            <IndexRoute
              onEnter={logRequestWrapper}
              component={FNAnalysisFNStatementsIncomeStatement}
            />
            <Route
              path="IncomeStatement"
              component={FNAnalysisFNStatementsIncomeStatement}
              onEnter={logRequestWrapper}
            />
            <Route
              path="CashFlow"
              onEnter={logRequestWrapper}
              component={FNAnalysisFNStatementsCashFlow}
            />
            <Route
              path="BalanceSheet"
              component={FNAnalysisFNStatementsBalanceSheet}
              onEnter={logRequestWrapper}
            />
          </Route>
          <Route
            path="competitive"
            component={CompetitiveAnalysis}
            onEnter={logRequestWrapper}
          />
          <Route
            path="ValuationsResults"
            onEnter={logRequestWrapper}
            component={Results}
          />
        </Route>
        <Route
          path="knowledge-base"
          onEnter={logRequestWrapper}
          component={KnowledgeBase}
        />
      </Route>
      <Route path="op" onEnter={redirectToLoginWrapper}>
        <IndexRoute onEnter={logRequestWrapper} component={Analysis} />
        <Route
          path="audit-trail"
          onEnter={logRequestWrapper}
          component={AuditTrail}
        />
        <Route path="analysis" onEnter={logRequestWrapper}>
          <IndexRoute onEnter={logRequestWrapper} component={Analysis} />
          <Route
            path="market"
            onEnter={logRequestWrapper}
            component={MarketAnalysis}
          />
          <Route
            path="financial"
            onEnter={logRequestWrapper}
            component={FinancialAnalysis}
          />
          <Route
            path="competitive"
            component={CompetitiveAnalysis}
            onEnter={logRequestWrapper}
          />
          <Route
            path="economic"
            onEnter={logRequestWrapper}
            component={EconomicAnalysis}
          />
        </Route>
        <Route path="results" onEnter={logRequestWrapper}>
          <IndexRoute onEnter={logRequestWrapper} component={Results} />
          <Route
            path="FinancialAnalysis"
            onEnter={logRequestWrapper}
            component={FNAnalysisFNStatements}
          >
            <IndexRoute
              onEnter={logRequestWrapper}
              component={FNAnalysisFNStatementsIncomeStatement}
            />
            <Route
              path="IncomeStatement"
              component={FNAnalysisFNStatementsIncomeStatement}
              onEnter={logRequestWrapper}
            />
            <Route
              path="CashFlow"
              onEnter={logRequestWrapper}
              component={FNAnalysisFNStatementsCashFlow}
            />
            <Route
              path="BalanceSheet"
              component={FNAnalysisFNStatementsBalanceSheet}
              onEnter={logRequestWrapper}
            />
          </Route>
          <Route
            path="competitive"
            component={CompetitiveAnalysis}
            onEnter={logRequestWrapper}
          />
          <Route
            path="ValuationsResults"
            onEnter={logRequestWrapper}
            component={Results}
          />
        </Route>
        <Route
          path="knowledge-base"
          onEnter={logRequestWrapper}
          component={KnowledgeBase}
        />
      </Route>
      <Route path="fn" onEnter={redirectToLoginWrapper}>
        <IndexRoute onEnter={logRequestWrapper} component={Analysis} />
        <Route
          path="audit-trail"
          onEnter={logRequestWrapper}
          component={AuditTrail}
        />
        <Route path="analysis" onEnter={logRequestWrapper}>
          <IndexRoute onEnter={logRequestWrapper} component={Analysis} />
          <Route
            path="market"
            onEnter={logRequestWrapper}
            component={MarketAnalysis}
          />
          <Route
            path="financial"
            onEnter={logRequestWrapper}
            component={FinancialAnalysis}
          />
          <Route
            path="competitive"
            component={CompetitiveAnalysis}
            onEnter={logRequestWrapper}
          />
          <Route
            path="economic"
            onEnter={logRequestWrapper}
            component={EconomicAnalysis}
          />
        </Route>
        <Route path="results">
          <IndexRoute onEnter={logRequestWrapper} component={Results} />
          <Route
            path="FinancialAnalysis"
            onEnter={logRequestWrapper}
            component={FNAnalysisFNStatements}
          >
            <IndexRoute
              onEnter={logRequestWrapper}
              component={FNAnalysisFNStatementsIncomeStatement}
            />
            <Route
              path="IncomeStatement"
              component={FNAnalysisFNStatementsIncomeStatement}
              onEnter={logRequestWrapper}
            />
            <Route
              path="CashFlow"
              onEnter={logRequestWrapper}
              component={FNAnalysisFNStatementsCashFlow}
            />
            <Route
              path="BalanceSheet"
              component={FNAnalysisFNStatementsBalanceSheet}
              onEnter={logRequestWrapper}
            />
          </Route>
          <Route
            path="competitive"
            component={CompetitiveAnalysis}
            onEnter={logRequestWrapper}
          />
          <Route
            path="ValuationsResults"
            onEnter={logRequestWrapper}
            component={Results}
          />
        </Route>
        <Route
          path="knowledge-base"
          onEnter={logRequestWrapper}
          component={KnowledgeBase}
        />
      </Route>
      <Route
        path="dashboard"
        onEnter={redirectToLoginWrapper}
        component={Dashboard}
      />
      <Route path="analysis/team-reports" component={Analysis} />
      <Route path="analysis/team-reports/:report1" component={Analysis} />
      <Route
        path="analysis/team-reports/:report1/:report2"
        component={Analysis}
      />
      <Route path="analysis/bcase" component={BusinessCase} />
      <Route path="analysis/bcase/:part" component={BusinessCase} />
      {/* Instructor-facing audit-trail viewer. AuditTrail page reads
          team_id from the query string before falling back to
          Auth.getTeamId(), so the dashboard Team Lookup can open it
          for any team in the course. */}
      <Route path="analysis/audit-trail" component={AuditTrail} />
      <Redirect path="analysis" to="analysis/team-reports" />
      <Route path="checkout/success" onEnter={redirectToLoginWrapper} component={() => <div />} />
      <Route path="checkout/cancel" onEnter={redirectToLoginWrapper} component={() => <div />} />
      <Route path="*" component={() => <div>Page not found</div>} />
    </Route>
  </Router>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/index.js